<template>
  <td
    v-for="(cell, index) in filteredCells"
    :key="cell.key"
    :class="styles.body"
    class="tw-transition-all"
  >
    <a
      v-if="isObjectWithLink(cell.value)"
      :href="cell.value.documentLink"
      target="_blank"
    >
      <i class="fa fa-solid fa-file-pdf" />
    </a>
    <div v-else :data-testid="`sf-column-${index}`">
      <slot name="cell-display" :cell="cell" :index="index">
        {{ cell.value }}
      </slot>
    </div>
  </td>
</template>

<script setup lang="ts" generic="TR extends BaseTableRow">
import type { BaseTableRow } from './types'
import { isObjectWithLink } from './predicates'

import type { TableVariants } from './constants'
import { tableVariants } from './constants'
import { useFilteredCells } from './use-filtered-cells'
import { useTableStyles } from './use-cell-styles'

interface Props {
  ignoredColumns?: string[]
  rowData: TR
  variant?: TableVariants
}

const {
  ignoredColumns = [],
  rowData,
  variant = tableVariants.DEFAULT,
} = defineProps<Props>()

const { filteredCells } = useFilteredCells<TR>(
  () => rowData,
  () => ignoredColumns
)
const { styles } = useTableStyles(() => variant)
</script>
